import * as S from "./SideMenu.style";
import { Buttons } from "@/components/atoms/Buttons";
import { SideMenus } from "@/data/menus";
import { useNavigate } from "react-router";
import { SideMenuList } from "@/components/molecules/SideMenuList";

interface SideMenuProps {
  version: string;
}

export const SideMenu = ({ version }: SideMenuProps) => {
  const navigate = useNavigate();

  return (
    <S.SideMenu>
      <SideMenuList data={SideMenus} />
      <S.SideMenuVersion>
        <Buttons
          type="button"
          size="sm"
          width="80px"
          layout="text"
          color="primary100"
          label="회원 탈퇴"
          onClick={() => navigate("/setting/withdraw")}
        />
        <span>ver.{version}</span>
      </S.SideMenuVersion>
    </S.SideMenu>
  );
};
